import { of } from 'rxjs'
import { find, identity, includes, isUndefined, assign } from '../libraries/lodash'
import RESPONSES, { RESPONSE_BADDATA, RESPONSE_BADRESPONSE, RESPONSE_NOTFOUND, RESPONSE_OFFLINE, RESPONSE_PENDING, RESPONSE_UNAUTHORIZED, RESPONSE_FORBIDDEN } from '../constants/responses'

const invalidData = (v) => includes([RESPONSE_PENDING, RESPONSE_OFFLINE, RESPONSE_BADRESPONSE, RESPONSE_BADDATA, RESPONSE_NOTFOUND, RESPONSE_UNAUTHORIZED, RESPONSE_FORBIDDEN], v)

export const isValidResponse = function (response) {
  return !includes(RESPONSES, response)
}

export const mapResponse = function (map, culpritMap = identity) {
  return function () {
    const culprit = find([...arguments], invalidData)
    if (!isUndefined(culprit)) {
      return culpritMap(culprit)
    }
    return map(...arguments)
  }
}

export const flatMapResponse = function (map) {
  return mapResponse(map, (culprit) => of(culprit))
}

export const mergeResponses = mapResponse(assign)
